import gql from 'graphql-tag';
export default gql`
  mutation updateSalesforceLead($leadId: String!, $payload: JSON!) {
    updateSalesforceLead(leadId: $leadId, payload: $payload) {
      status
      message
    }
  }
`;
